document.querySelectorAll('.site-nav__element').forEach(function (element) {
    if (element.classList.contains('site-nav--active')) {
        element.querySelector('.site-nav__submenu').style.display = 'block';
    }
});

document.querySelectorAll('.child-click-btn').forEach(function (element) {
    if (element.classList.contains('site-nav--active')) {
        element.closest('.site-nav__submenu').style.display = 'block';
        if(element.classList.contains('site-nav__submenu-grand')) {
            element.querySelector('.site-nav__submenu-grand').style.display = 'block';
        }

    }
});

document.querySelectorAll('.child-click-btn-grand').forEach(function (element) {
    if (element.classList.contains('site-nav--active')) {
        element.closest('.site-nav__submenu').style.display = 'block';
        element.closest('.site-nav__submenu-grand').style.display = 'block';
    }
});